import {defaultNotificationResult} from '../../service/notification/notification-const';

import {NotificationContextType} from './notification-type';

export const defaultNotificationContext: NotificationContextType = {
    notificationResult: defaultNotificationResult,
    markAllNotificationAsRead: () => Promise.resolve(),
    markNotificationAsRead: () => Promise.resolve(),
};
